<template>
    <div class="container">
        <template v-if="offices.length > 0">
            <div class="contact__body">
                <div class="contact__col">
                    <h2 class="contact__col-mobile-title">
                        Контакты
                    </h2>
                    <div class="contact__item">
                        <div class="contact__item-title">
                            Email
                        </div>
                        <div class="contact__item-text">
                            {{currentOffice.email}}
                        </div>
                    </div>
                    <div class="contact__item">
                        <div class="contact__item-title">
                            Телефон
                        </div>
                        <div class="contact__item-text">
                            {{currentOffice.phone}}
                        </div>
                    </div>
                    <div class="contact__item">
                        <div class="contact__item-title">
                            Адрес
                        </div>
                        <div class="contact__item-text">
                            <v-select :options="cities" v-model="currentCity"></v-select>
                            <v-select :options="addresses" v-model="currentAddress"></v-select>
                        </div>
                    </div>
                    <div class="contact__item-row ">
                        <div class="contact__item-row-title">
                            Телефон:
                        </div>

                        <div class="contact__item-row-text">
                            {{currentOffice.phone}}
                        </div>
                    </div>
                    <div class="contact__item-row">
                        <div class="contact__item-row-title">
                            Режим работы:
                        </div>
                        <div class="contact__item-row-text">
                            {{currentOffice.work_time}}
                        </div>
                    </div>
                </div>
                <offices :key="currentOffice.id" v-if="currentOffice.coordinates" class="desktop-map" :list="[currentOffice]"></offices>
            </div>
            <a class="contact__mobile-map-link" @click.prevent="show=!show" href="#">Найти на карте</a>
            <div class="modal-window" v-show="show">
                <div class="modal-window__top">
                    <a href="#" class="modal-window__close" @click.prevent="show=!show">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.45714 0L8.5 7.04286L15.5429 0L17 1.45714L9.95714 8.5L17 15.5429L15.5429 17L8.5 9.95714L1.45714 17L0 15.5429L7.04286 8.5L0 1.45714L1.45714 0Z" fill="#313131"/>
                        </svg>
                    </a>
                </div>
                <div class="modal-window__body">
                    <offices :key="currentOffice.id" v-if="currentOffice.coordinates" class="mobile-map" :list="[currentOffice]"></offices>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import "vue-select/dist/vue-select.css";
    import vSelect from "vue-select";

    Vue.component("v-select", vSelect);
    export default {
        data() {
            return {
                offices: [],
                currentCity: null,
                currentAddress: null,
                show: false
            }
        },
        watch: {
            currentCity(val, oldVal) {
                if(oldVal && oldVal != val) {
                    this.currentAddress = this.addresses[0];
                }
            }
        },
        computed: {
            cities() {
                return _.uniq(this.offices.map(i => i.city));
            },
            addresses() {
                return this.offices.filter(i => i.city == this.currentCity).map(i => i.address);
            },
            currentOffice() {
                return this.offices.find(i => i.city == this.currentCity && i.address == this.currentAddress)
            }
        },
        methods: {
            async getOffices() {
                await axios.get('/api/offices').then(response => {
                    this.offices = response.data;
                    if (this.offices.length > 0) {
                        this.currentCity = this.offices[0].city;
                        this.currentAddress = this.offices[0].address;
                    }
                })
            }
        },
        async mounted() {
            await this.getOffices();
        }
    }
</script>

